// 서버 오류 응답에서 사용자에게 보여줄 사유를 꺼낸다.
//
// ⛔ 백엔드 오류 본문은 두 형식이 섞여 있다 (df_backend_custom#2175).
//   - DefaultException 계열: 평문 문자열 본문 (Content-Type text/html)
//   - StructuredException: JSON {message, status_code, details}
//   - 직접 jsonify 한 JSON {msg, ...} (예: Dictionary 삭제 거절 {msg, def_pd})
// data.message 만 보면 평문 사유("Not found project_codes : X" 등)가 통째로 버려진다.
// 백엔드가 JSON 하나로 통일되면 문자열 분기는 지운다.
function getErrorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    if (typeof data === 'string') {
        const text = data.trim();
        // HTML 에러 페이지(<!doctype html>, <html> 등)는 사용자에게 보여줄 문구가 아니다.
        return text && !/^</.test(text) ? text : fallback;
    }
    return (data && (data.message || data.error || data.msg)) || fallback;
}

// 테스트(node --test, CI Node 16)가 require 로 읽으므로 CommonJS 로 내보낸다 (aiQnaPresentation.js 와 같은 관례).
module.exports = { getErrorMessage };
